import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, withKeys as _withKeys, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "tfa-modal" }
const _hoisted_2 = { class: "tfa-head" }
const _hoisted_3 = {
  key: 0,
  class: "tfa-loading"
}
const _hoisted_4 = { class: "tfa-codes" }
const _hoisted_5 = { class: "tfa-actions" }
const _hoisted_6 = { class: "tfa-status tfa-status--on" }
const _hoisted_7 = { class: "tfa-field" }
const _hoisted_8 = {
  key: 0,
  class: "tfa-error"
}
const _hoisted_9 = { class: "tfa-actions" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = ["disabled"]
const _hoisted_12 = { class: "tfa-qr-wrap" }
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "tfa-manual" }
const _hoisted_15 = { class: "tfa-field" }
const _hoisted_16 = {
  key: 0,
  class: "tfa-error"
}
const _hoisted_17 = { class: "tfa-actions" }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = {
  key: 0,
  class: "tfa-error"
}
const _hoisted_20 = { class: "tfa-actions" }
const _hoisted_21 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "tfa-overlay",
    onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["self"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[12] || (_cache[12] = _createElementVNode("h3", { class: "tfa-title" }, "Verificação em duas etapas (2FA)", -1)),
        _createElementVNode("button", {
          class: "tfa-x",
          type: "button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        }, "✕")
      ]),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Carregando..."))
        : (_ctx.recoveryCodes.length)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _cache[13] || (_cache[13] = _createElementVNode("p", { class: "tfa-sub" }, [
                _createTextVNode("Guarde estes "),
                _createElementVNode("strong", null, "códigos de recuperação"),
                _createTextVNode(" num lugar seguro. Cada um funciona "),
                _createElementVNode("strong", null, "uma única vez"),
                _createTextVNode(" caso você perca acesso ao app autenticador. Eles não serão mostrados de novo.")
              ], -1)),
              _createElementVNode("div", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recoveryCodes, (c) => {
                  return (_openBlock(), _createElementBlock("code", {
                    key: c,
                    class: "tfa-code"
                  }, _toDisplayString(c), 1))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("button", {
                  class: "tfa-btn tfa-btn--ghost",
                  type: "button",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.copyCodes && _ctx.copyCodes(...args)))
                }, _toDisplayString(_ctx.copied ? 'Copiado!' : 'Copiar'), 1),
                _createElementVNode("button", {
                  class: "tfa-btn tfa-btn--primary",
                  type: "button",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.finishRecovery && _ctx.finishRecovery(...args)))
                }, "Guardei, concluir")
              ])
            ], 64))
          : (_ctx.status && _ctx.status.enabled)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createElementVNode("div", _hoisted_6, [
                  _cache[14] || (_cache[14] = _createElementVNode("svg", {
                    width: "16",
                    height: "16",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2.4"
                  }, [
                    _createElementVNode("polyline", { points: "20 6 9 17 4 12" })
                  ], -1)),
                  _createTextVNode(" 2FA ativo · " + _toDisplayString(_ctx.status.recoveryCodesRemaining) + " código(s) de recuperação restante(s) ", 1)
                ]),
                _cache[16] || (_cache[16] = _createElementVNode("p", { class: "tfa-sub" }, "O mesmo segredo pode estar em vários apps (celular e PC). Para adicionar um novo aparelho, desative e reative escaneando o QR em todos.", -1)),
                _createElementVNode("div", _hoisted_7, [
                  _cache[15] || (_cache[15] = _createElementVNode("label", null, "Senha do administrador (para alterar o 2FA)", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.pwd) = $event)),
                    type: "password",
                    autocomplete: "current-password",
                    placeholder: "Sua senha"
                  }, null, 512), [
                    [_vModelText, _ctx.pwd]
                  ])
                ]),
                (_ctx.error)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.error), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("button", {
                    class: "tfa-btn tfa-btn--ghost",
                    type: "button",
                    disabled: _ctx.busy,
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.regenRecovery && _ctx.regenRecovery(...args)))
                  }, "Gerar novos códigos", 8, _hoisted_10),
                  _createElementVNode("button", {
                    class: "tfa-btn tfa-btn--danger",
                    type: "button",
                    disabled: _ctx.busy,
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.disable2fa && _ctx.disable2fa(...args)))
                  }, "Desativar 2FA", 8, _hoisted_11)
                ])
              ], 64))
            : (_ctx.setupData)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                  _cache[20] || (_cache[20] = _createElementVNode("p", { class: "tfa-sub" }, [
                    _createTextVNode("1. Escaneie o QR no seu app autenticador (Google Authenticator, Authy, 1Password...). "),
                    _createElementVNode("strong", null, "Escaneie em todos os aparelhos que quiser"),
                    _createTextVNode(" (celular + PC).")
                  ], -1)),
                  _createElementVNode("div", _hoisted_12, [
                    (_ctx.qrDataUrl)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: _ctx.qrDataUrl,
                          alt: "QR 2FA",
                          class: "tfa-qr"
                        }, null, 8, _hoisted_13))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("p", _hoisted_14, [
                    _cache[17] || (_cache[17] = _createTextVNode("Ou digite a chave manualmente:", -1)),
                    _cache[18] || (_cache[18] = _createElementVNode("br", null, null, -1)),
                    _createElementVNode("code", null, _toDisplayString(_ctx.setupData.secret), 1)
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _cache[19] || (_cache[19] = _createElementVNode("label", null, "2. Digite o código de 6 dígitos gerado pelo app", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.confirmCode) = $event)),
                      type: "text",
                      inputmode: "numeric",
                      placeholder: "000000",
                      onKeyup: _cache[7] || (_cache[7] = _withKeys(
//@ts-ignore
(...args) => (_ctx.enable2fa && _ctx.enable2fa(...args)), ["enter"]))
                    }, null, 544), [
                      [_vModelText, _ctx.confirmCode]
                    ])
                  ]),
                  (_ctx.error)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(_ctx.error), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("button", {
                      class: "tfa-btn tfa-btn--ghost",
                      type: "button",
                      onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.cancelSetup && _ctx.cancelSetup(...args)))
                    }, "Cancelar"),
                    _createElementVNode("button", {
                      class: "tfa-btn tfa-btn--primary",
                      type: "button",
                      disabled: _ctx.busy,
                      onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.enable2fa && _ctx.enable2fa(...args)))
                    }, "Ativar 2FA", 8, _hoisted_18)
                  ])
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                  _cache[21] || (_cache[21] = _createElementVNode("div", { class: "tfa-status tfa-status--off" }, "2FA desativado", -1)),
                  _cache[22] || (_cache[22] = _createElementVNode("p", { class: "tfa-sub" }, "Adicione uma segunda camada de proteção ao painel administrativo. Você vai precisar de um app autenticador no celular e/ou PC. Geramos códigos de recuperação para o caso de perder o aparelho.", -1)),
                  (_ctx.error)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(_ctx.error), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("button", {
                      class: "tfa-btn tfa-btn--primary",
                      type: "button",
                      disabled: _ctx.busy,
                      onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.startSetup && _ctx.startSetup(...args)))
                    }, "Ativar 2FA", 8, _hoisted_21)
                  ])
                ], 64))
    ])
  ]))
}